/**
 * Treats Quill/HTML non-breaking spaces as ordinary word spaces.
 * Does not collapse consecutive spaces or rewrite surrounding markup.
 * @param {*} text
 * @returns {*}
 */
export default (function normalizeNbsp(text) {
  if (text == null || text === "") {
    return text;
  }
  return String(text).replace(/&nbsp;/gi, " ").replace(/&#160;/gi, " ").replace(/&#x0*a0;/gi, " ").replace(/\u00A0/g, " ");
});